<div class="icon-slider">
  <swiper-container
    [attr.slides-per-view]="slidesPerView()"
    (swiperinit)="onSwiper($event)"
    [ngClass]="{ 'full-width': swiper?.isBeginning && swiper?.isEnd }"
    >
    @for (item of items | async; track item) {
      <swiper-slide>
        <a class="icon-slide" [attr.href]="item.link" target="_parent" [attr.aria-label]="item.title">
          @if (item.kxIcon) {
            <div class="icon">
              <kx-icon size="xl" [id]="item.kxIcon"></kx-icon>
            </div>
          }
          @if (!item.kxIcon) {
            <div
              class="img"
              [ngStyle]="getImgStyle(item.imageUrl)"
            ></div>
          }
          <div class="text">
            <span
              class="head"
              [ngClass]="{ 'small-text': item.title.length > 64 }"
              >
              {{ item.title }}
            </span>
            <span class="subhead">
              {{ item.description }}
            </span>
          </div>
        </a>
      </swiper-slide>
    }
  </swiper-container>

  @if (!swiper?.isBeginning) {
    <button
      (click)="navigateTo(swiper.activeIndex - 1)"
      class="prev-btn"
      >
      <app-slider-arrow-icon direction="left"></app-slider-arrow-icon>
    </button>
  }
  @if (!swiper?.isEnd) {
    <button
      (click)="navigateTo(swiper.activeIndex + 1)"
      class="next-btn"
      >
      <app-slider-arrow-icon direction="right"></app-slider-arrow-icon>
    </button>
  }
</div>
